module.exports = __webpack_public_path__ + "img/rx1hs.638a6d77.jpg";